import React from "react";
import PropTypes from "prop-types";
import { H3 } from "components/core/Typography";
import Container from "components/atoms/Container";
import NearbyCard from "components/atoms/NearbyCard";

import "./NearbyCityRow.scss";

const NearbyCityRow = ({ rowTitle, nearbyCities }) => (
	<div className="nearby-city-row">
		<Container>
			<H3
				size="large"
				weight="bold"
			>
				{rowTitle}
			</H3>
			<div className="nearby-city-container">
				{nearbyCities.map((city) => (
					<NearbyCard
						city={city}
						key={city.content_id}
					/>
				))}
			</div>
		</Container>
	</div>
);

NearbyCityRow.propTypes = {
	rowTitle: PropTypes.string,
	nearbyCities: PropTypes.arrayOf(PropTypes.object)
};

export default NearbyCityRow;
